var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarketing = function SvgMarketing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Marketing_svg__a)",
    d: "m14.697 37.486 7.356 7.357a3.814 3.814 0 1 0 5.393-5.392L12 24.003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m14.697 37.486 7.356 7.357a3.814 3.814 0 1 0 5.393-5.392L12 24.003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "m20.614 3.697-9.522 20.308-8.975 8.975a3.814 3.814 0 0 0 0 5.394l2.697 2.696a3.814 3.814 0 0 0 5.393 0l8.975-8.975 20.308-9.521"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m20.614 3.697-9.522 20.308-8.975 8.975a3.814 3.814 0 0 0 0 5.394l2.697 2.696a3.814 3.814 0 0 0 5.393 0l8.975-8.975 20.308-9.521M42.187 25.27 17.918 1M38.309 10.602l3.88-1.975M32.586 4.881 34.56 1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeWidth: 1.5,
    d: "m11.5 24 8 8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Marketing_svg__a",
    x1: 18.5,
    x2: 28.798,
    y1: 34,
    y2: 42.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgMarketing;